
import Component from 'vue-class-component';
import Vue from 'vue';
import { Prop } from 'vue-property-decorator';

@Component
export default class LoanNavHelpCenter extends Vue {
	@Prop({ required: true })
	loanId!: string;
}

